import Radio, { RadioChangeEvent } from 'antd/lib/radio';
import { IViewSwitcher } from './viewInterface';

export const ViewSwitcher = ({ viewOptions, view, handleViewMode }: IViewSwitcher) => {
    const handleView = (e: RadioChangeEvent) => {
        handleViewMode(e.target.value);
    };

    return (
        <Radio.Group value={view} buttonStyle="solid" onChange={handleView}>
            {viewOptions.map(
                view =>
                    view.isVisible && (
                        <Radio.Button value={view.value} data-cy={`view-${view.value}`} key={view.value}>
                            {view?.icon || ''}&nbsp;{view.title}
                        </Radio.Button>
                    )
            )}
        </Radio.Group>
    );
};
